// removed by extract-text-webpack-plugin
module.exports = {"btn":"_29uH4-Eb51DutH52ndyK13","success":"C45wgmjmVVRIZ-d2-6FwP","danger":"UP8j9FlanXDsj8mIruZ4V","rounded":"_1j1YhrCdvJ2wodGaFpjMiL","rounded-orange":"_1zZHDthCJLG-wMOrQTo7gi","light":"_3GuR2S799exc02j_feVD6B"};


//////////////////
// WEBPACK FOOTER
// ./src/components/molecules/ActionBtnIcon/style.css
// module id = 269
// module chunks = 42